import { axios } from './apiClient';
import { DataStorageObject, TransactionStatus } from '../models/data-storage.model';

export type StartLegitimationParams = {
  transactionId: string;
  token: string;
  isOnfidoMotionEnabled: boolean;
};
export type ValidateLegitimationResultParams = {
  transactionId: string;
  token: string;
};

export type StartLegitimationResponse = {
  redirectUrl: string;
  status?: TransactionStatus;
};

export const requestLegitimationStart = async (params: StartLegitimationParams): Promise<StartLegitimationResponse> => {
  const { transactionId, token, isOnfidoMotionEnabled } = params;
  const response = await axios.post<StartLegitimationResponse>(
    `/legitimation/process-initialization/${transactionId}`,
    { isOnfidoMotionEnabled },
    {
      headers: {
        Authorization: token
      }
    }
  );

  if (response.data.status === TransactionStatus.CANCELED) {
    return { redirectUrl: '/expired' };
  }

  return response.data;
};

export const requestLegitimationResultValidation = async (
  params: ValidateLegitimationResultParams
): Promise<DataStorageObject> => {
  const { transactionId, token } = params;
  const response = await axios.post<DataStorageObject>(
    `/legitimation/data/${transactionId}`,
    {},
    {
      headers: {
        Authorization: token
      }
    }
  );
  return response.data;
};
